import React, { useEffect } from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"
import './Home.css'
import pic from './images/miti.png'
import pico from './images/prog.png'
import picos from './images/Saly-1.png'
import picoes from './images/milan.png'
import mit from './images/meet.jpeg'
export default function Home() {
   useEffect( ()=>{
    Aos.init({duration: 2000})
   },[])
  return (
    <>
      <div className="container py-3">
        <div className="row">
          <div className="col-sm-6">
            <h1 className='head' data-aos="fade-left">Knowledge is a  <br /> commodity to be shared<br />  </h1>
            <p className='para mt-3' data-aos="fade-left">A commuinity by self learners for self learners.  <br /> </p>
            <a href="https://chat.whatsapp.com/DdpIIRn46vnGoTDAe8yXi1"><button class="btn btn-outline-warning mt-2 mb-3" data-aos="fade-up">Join Us</button></a>
          </div>
          <div className="col-sm-6 py-3">
            <img src={pic} alt="" className='img-fluid mt-3' data-aos="fade-up"/>
          </div>
        </div>
      </div>

      {/* // about page */}
      <div className="container-fluid unique" id='#milans'  >
        <div className="container">
          <div className="row ">
            <div className="col-sm-6">
              <h1 className="bot mt-4" data-aos="fade-left">About Us</h1>
              <img src={pico} alt="" className='img-fluid mt-3'data-aos="fade-up" />
            </div>
            <div className="col-sm-6 mt-5" data-aos="fade-left">
              <p className="dota">AAO CODE KARE is a coding community founded by self-learners, for selflearners. We are a close-knit community  of students who have solitarily become proficient and mastered in various technologies. </p>
            </div>
          </div>
        </div>
      </div>


      {/* Our vision */}
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 mt-4">
              <h1 className="bot mt-2"data-aos="fade-left">Our Vision</h1>
              <p className="dota" data-aos="fade-left">
                “Knowledge should be affordable for those with a desire to learn ” We visualize that education in the present world, focused on materialism, should be affordableunlike some establishments costing  you a hefty amount and crippling your  morals under debts to acquire a  particular skill.
              </p>
            </div>
            <div className="col-sm-6">
              <img src={picos} alt="" className='img-fluid mt-3' data-aos="fade-up"/>
            </div>
          </div>
        </div>
      </div>



      {/* Our Mission */}
      <div className="container-fluid unique">
        <div className="container">
          <div className="row ">
            <div className="col-sm-6 mt-4">
              <h1 className="bot" data-aos="fade-left">Our Mission</h1>
              <img src={picoes} alt="" className='img-fluid mt-3'data-aos="fade-up" />
            </div>
            <div className="col-sm-6 mt-5" data-aos="fade-left">
              <p className="dota">We are a group of students, assisting and encouraging other students to acquire industry level skills. Aao Code Kare is a programmers ’community where newcomers and professionals come together to help each other and share knowledge free of cost, we are a non-Profit community that helps newcomers to adapt to the tech world with by providing free resources
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* Founder's Note */}
      <div className="container-fluid">
        <div className="container d-flex justify-content-center align-item-center">
          <div class="col-md-4">
            <div class="text-center">
              <h1 className="bot">Founder</h1>
              <img src={mit} alt="" class="rounded-circle " width="240px" height="220px" data-aos="fade-up"/>
              <h5 className='mt-3'data-aos="fade-left">Founder</h5>
              <h5 className='bold' data-aos="fade-left">Meet Bhanushali</h5>
              <p style={{ opacity: "0.8" }} data-aos="fade-left" >Automation Engineer at  <span style={{ color: "red" }}>Amazon</span> </p>
              <ul class="viram" data-aos="fade-left">
                <li><a href="https://instagram.com/virambhadra?igshid=YmMyMTA2M2Y=https://twitter.com/Virambhadra?t=Ht-DIcMlfc3NPnlFXwx2yA&s=09" ><i class="fa fa-instagram bhadra"></i></a></li>
                <li><a href="https://twitter.com/Virambhadra?t=TrzEkdaALhHK2kli1W8AOg&s=09" ><i class="fa fa-twitter tvit"></i></a></li>
                <li><a href="https://github.com/virambhadra" ><i class="fa fa-github kala"></i></a></li>
                <li><a href="https://www.linkedin.com/in/virambhadra" ><i class="fa fa-linkedin blue"></i></a></li>
              </ul>
              {/* <p style={{ opacity: "0.6" }}>  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint fuga illum, voluptatum repellat cum molestias, nemo cupiditate vitae mollitia numquam dolore alias beatae asperiores rem odio quam quia corrupti nesciunt obcaecati velit minus voluptas. Vitae voluptatum officia laboriosam quam perspiciatis consequuntur blanditiis. Cupiditate, sed error. </p> */}

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
